<template>
  <b-modal
    id="change-bilan-type-operation-modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Validate')"
    :title="modalTitle"
    cancel-variant="danger"
    centered
    ok-variant="primary"
    @ok="handleOk"
  >
    <div>
      <p>{{ mainText }}</p>
      <p>{{ subText }}</p>
    </div>
  </b-modal>
</template>

<script>
import api from "../../../services/api";

export default {
  name: "ChangeBilanTypeOperationModal",

  props: {
    operationId: {
      type: Number,
      required: true,
    },
    bilanTypeName: {
      required: true,
    },
    alreadyHasExe: {
      type: Boolean,
      required: true,
    }
  },

  emits: ['didChangeBilanType'],

  computed: {
    modalTitle() {
      return this.alreadyHasExe
        ? this.$t('operation.change.type.bilan')
        : this.$t('operation.create.bilan.exe');
    },
    mainText() {
      if (this.alreadyHasExe) {
        return this.$t('operation.change.type.bilan.text') + (this.bilanTypeName === 'AVP' ? ' EXE' : ' AVP') + ' ?';
      } else {
        return this.bilanTypeName === 'EXE'
          ? this.$t('operation.change.type.bilan.text') + ' AVP ?'
          : this.$t('operation.create.bilan.exe.text');
      }
    },
    subText() {
      if (this.alreadyHasExe) {
        return this.$t('operation.change.type.bilan.subtext', {
          bilanDestination: this.bilanTypeName === 'AVP' ? 'EXE' : 'AVP',
          bilanCurrent: this.bilanTypeName,
        });
      } else {
        return this.$t('operation.change.type.bilan.subtext', {
          bilanDestination: this.bilanTypeName === 'EXE' ? 'AVP' : 'EXE',
          bilanCurrent: this.bilanTypeName,
        });
      }
    }
  },

  methods: {
    handleOk() {
      this.handleSubmit();
    },

    handleSubmit() {
      const data = new FormData();
      data.append('operationId', this.operationId);

      api({
        method: 'POST',
        url: `/operation/changeBilanType/${this.operationId}`,
        data: data
      })
        .then(response => {
          this.$emit('didChangeBilanType', response.data.bilanType);
          this.hideModal();
        });
    },

    hideModal() {
      this.$bvModal.hide('change-bilan-type-operation-modal');
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/ChangeBilanTypeOperationModal.vue